import Link from 'app/components/presentation/link/Link';
import { User } from 'app/constants/schemas';
import { getAuthUser, isTeacher } from 'app/models/auth/selectors';
import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { TEACHER_RTC_GUIDE_URL } from 'app/constants/TeacherSite';
import { useBrand } from '../OrganizationContext';

interface IProps {
  className?: string;
  children: ReactNode;
  target?: string;
  user?: User;
}

const TroubleshootingLink = ({ user, target, ...props }: IProps) => {
  const brand = useBrand();
  const to = isTeacher(user) ? TEACHER_RTC_GUIDE_URL : brand.rtcGuideUrl;
  return (<Link to={to} {...props} target={target} />);
};

export default connect((state) => ({ user: getAuthUser(state) }), {})(TroubleshootingLink);
